import { Box } from '@air/zephyr';
import { useEffect, useRef } from 'react';

import { SectionData } from '~/lib/contentful/custom-types';
import { Container } from '~/old-marketing/components/Container';
import { Section } from '~/old-marketing/components/sections/Section';
import { SectionTitle } from '~/old-marketing/components/sections/SectionTitle';
import { worthlessStudiosTheme } from '~/old-marketing/components/sections/templates/worthless-studios/theme';

const TEMPLATE_KEY = 'worthless-studios-embedded-boards';

export type WorthlessStudiosEmbeddedBoardsTemplateProps = Pick<SectionData, 'additionalSettings' | 'id' | 'title'> & {
  isPreview?: boolean;
  isSubsection?: boolean;
};

export const WorthlessStudiosEmbeddedBoardsTemplate = ({
  additionalSettings,
  id,
  isSubsection,
  title,
}: WorthlessStudiosEmbeddedBoardsTemplateProps) => {
  const iframeRef = useRef<HTMLIFrameElement | null>(null);

  useEffect(() => {
    if (iframeRef?.current) {
      iframeRef.current.addEventListener('load', () => {
        const style = document.createElement('style');

        style.appendChild(
          document.createTextNode(`
            .ReactVirtualized__List { padding-bottom: 0 !important; }
            [data-testid="list-section-title"] {
              display: none;
            }
            [data-testid="banner-container"] {
              display: none;
            }
            [data-testid="PUBLIC_BOARD_CHILDREN_CONTAINER"] {
              margin-right: 0 !important;
            }
            [data-testid="JOIN_BANNER"] {
              display: none;
            }
            [data-testid="PUBLIC_BOARD_SIDE_NAV"] {
              display: none;
            }
            [data-testid="VIEW_CONTROLS"] {
              display: none;
            }
            [data-testid="BOARD_BLURB_TITLE"] {
              display: none;
            }
            [data-testid="BOARD_BLURB_DESCRIPTION"] {
              display: none;
            }
            [data-testid="WORKSPACE_STICKY_HEADER_CONTAINER"] {
              display: none;
            }
          `),
        );

        iframeRef?.current?.contentWindow?.document?.head?.appendChild(style);
      });
    }
  }, [iframeRef]);

  return (
    <Section
      className={worthlessStudiosTheme}
      css={{ paddingTop: 60, paddingBottom: 60, overflow: 'visible' }}
      id={id}
      templateKey={TEMPLATE_KEY}
    >
      <Container>
        {title && (
          <SectionTitle
            css={{ marginBottom: 32, color: '$pigeon800', textAlign: 'center' }}
            isSubsection={isSubsection}
            size="heading-56"
          >
            {title}
          </SectionTitle>
        )}

        {additionalSettings?.airPublicBoardUrl && (
          <Box
            as="iframe"
            ref={iframeRef}
            src={additionalSettings.airPublicBoardUrl}
            title="Air public board"
            tx={{ width: '100%', height: 700, maxHeight: '80vh', border: 0 }}
          />
        )}
      </Container>
    </Section>
  );
};

WorthlessStudiosEmbeddedBoardsTemplate.templateKey = TEMPLATE_KEY;
